/**
 developer-utils
 Created by RuSsCiTy on 20.09.2017
 **/
import { DEVELOP_MODE, SIMULATE_NETWORK_DELAY_IN_MS } from "../const/constants";

export const apiDelay = () => {
  return new Promise((resolve, reject) => {
    if (DEVELOP_MODE) {
      setTimeout(() => {
        resolve();
      }, SIMULATE_NETWORK_DELAY_IN_MS);
    } else {
      resolve();
    }
  });
};

export const isLocalhost = () => {
  return !(window.location.href.indexOf("localhost") < 0);
};

export const isInIframe = () => {
  try {
    // for reference: http://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t/326076#326076
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};



// WEBPACK FOOTER //
// ./src-cookie-manager/utils/developer-utils.js